import EditFormSubComponent from 'modules/ui/editform/subForm/EditFormSubComponent';
import EditFormPage from 'modules/ui/editform/EditFormPage';
import EditFormTextField from 'modules/ui/editform/fields/EditFormTextField';
import EditFormHtmlField from 'modules/ui/editform/fields/EditFormHtmlField';
import FejezetEditService from 'app/admin/fejezet/service/FejezetEditService';
import AsszociaciosKerdesEditService from 'app/admin/asszociacioskerdes/service/AsszociaciosKerdesEditService';
import EditFormSelectField from 'modules/ui/editform/fields/EditFormSelectField';
import FmStorageTableService from 'app/admin/fileManager/service/FmStorageTableService';
import FmBrowserTableService from 'app/admin/fileManager/service/FmBrowserTableService';
import nBossConnection from 'modules/base/service/nBossConnection';
import { withRouter, useParams } from 'react-router-dom';

const config = (data) => {
	return {
		key: 'asszociaciosKerdesEditForm',
		text: 'Asszociációs Kérdések',
		textKey: 'asszociacioskerdes',
		service: AsszociaciosKerdesEditService,
		icon: 'person',
		tabList: [
			{
				key: 'basic',
				text: 'Alapadatok',
				textKey: 'basic'
			},
			{
				key: 'kerdesAsszociacios',
				text: 'Kérdések',
				textKey: 'kerdesAsszociacios'
			},
			{
				key: 'leirasTetelAsszociacios',
				text: 'Leírás tételek',
				textKey: 'leirasTetelAsszociacios'
			}
		],
		fields: [
			{
				key: 'sorszamTol',
				text: 'Sorszám tól',
				textKey: 'sorszamTol',
				component: EditFormTextField,
				type: 'number',
				required: true
			},
			{
				key: 'alsorszamTol',
				text: 'Alsorszám tól',
				textKey: 'alsorszamTol',
				component: EditFormTextField,
				type: 'number',
				required: true
			},
			{
				key: 'subsorszamTol',
				text: 'Subsorszam tól',
				textKey: 'subsorszamTol',
				component: EditFormTextField,
				type: 'number',
				required: true
			},
			{
				key: 'sorszamIg',
				text: 'Sorszám ig',
				textKey: 'sorszamIg',
				component: EditFormTextField,
				type: 'number',
				required: true
			},
			{
				key: 'alsorszamIg',
				text: 'Alsorszám ig',
				textKey: 'alsorszamIg',
				component: EditFormTextField,
				type: 'number',
				required: true
			},
			{
				key: 'subsorszamIg',
				text: 'Subsorszam ig',
				textKey: 'subsorszamIg',
				component: EditFormTextField,
				type: 'number',
				required: true
			},
			/*{
				key: 'csorszam',
				text: 'Sorszám',
				textKey: 'csorszam',
				component: EditFormTextField,
				required: true
			},*/
			{
				key: 'leiras',
				text: 'Leírás',
				textKey: 'leiras',
				component: EditFormHtmlField,
				storageService: FmStorageTableService,
				browserService: FmBrowserTableService,
				getUrl: item => `${nBossConnection.basePath}fmBrowserTableControl/getFile?key=${item.key}`,
				required: true
			},
			{
				key: 'feladatCsoport',
				text: 'Feladatcsoport',
				textKey: 'feladatCsoport',
				component: EditFormSelectField,
				required: true,
				items: () => FejezetEditService.getFeladatCsoportSelection()
			},
			{
				key: 'kerdesAsszociacios',
				text: 'Kérdés',
				textKey: 'kerdesAsszociacios',
				tab: 1,
				component: EditFormSubComponent,
				watchTitleKey: 'csorszam',
				defaultValue: {
					id: null,
					csorszam: null,
					leiras: null,
					magyarazat: null,
					leirasTetel: []
				},
				fields: [
					{
						key: 'csorszam',
						text: 'Sorszám',
						textKey: 'csorszam',
						component: EditFormTextField,
						required: true
					},
					{
						key: 'leiras',
						text: 'Leírás',
						textKey: 'leiras',
						component: EditFormHtmlField,
						storageService: FmStorageTableService,
						browserService: FmBrowserTableService,
						getUrl: item => `${nBossConnection.basePath}fmBrowserTableControl/getFile?key=${item.key}`,
						required: true
					},
					{
						key: 'magyarazat',
						text: 'Magyarázat',
						textKey: 'magyarazat',
						component: EditFormHtmlField,
						storageService: FmStorageTableService,
						browserService: FmBrowserTableService,
						getUrl: item => `${nBossConnection.basePath}fmBrowserTableControl/getFile?key=${item.key}`,
						required: true
					},
					{
						key: 'leirasTetel',
						text: 'Leírás tétel',
						textKey: 'leirasTetel',
						component: EditFormSelectField,
						multiple: true,
						items: () => AsszociaciosKerdesEditService.getLeirasTetel(data.id)
					}
				]
			},
			{
				key: 'leirasTetelAsszociacios',
				text: 'Leírás tétel',
				textKey: 'leirasTetelAsszociacios',
				tab: 2,
				component: EditFormSubComponent,
				watchTitleKey: 'betujel',
				defaultValue: {
					id: null,
					betujel: null,
					szoveg: null,
					magyarazat: null
				},
				fields: [
					{
						key: 'betujel',
						text: 'Betűjel',
						textKey: 'betujel',
						component: EditFormTextField,
						required: true
					},
					{
						key: 'szoveg',
						text: 'Szöveg',
						textKey: 'szoveg',
						component: EditFormHtmlField,
						storageService: FmStorageTableService,
						browserService: FmBrowserTableService,
						getUrl: item => `${nBossConnection.basePath}fmBrowserTableControl/getFile?key=${item.key}`,
						required: true
					},
					{
						key: 'magyarazat',
						text: 'Magyarázat',
						textKey: 'magyarazat',
						component: EditFormHtmlField,
						storageService: FmStorageTableService,
						browserService: FmBrowserTableService,
						getUrl: item => `${nBossConnection.basePath}fmBrowserTableControl/getFile?key=${item.key}`,
						required: true
					}
					/*
					{
						key: 'kerdesAsszoc',
						text: 'Kérdés',
						textKey: 'kerdesAsszoc',
						component: EditFormSelectField,
						items: () => AsszociaciosKerdesEditService.getKerdesAsszoc(data.id)
					}
					*/
				]
			}
		]
	}
};

function AsszociaciosKerdesEditForm() {
	const { id } = useParams();
	const myConfig = config({
		id
	});
	return <EditFormPage config={myConfig} />;
}

export default withRouter(AsszociaciosKerdesEditForm);
